import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../../helpers/export'
import { getDefaultVsic } from '../../../../helper'
import InsuranceService from '../../core/InsuranceService'

export const postProfitability = createAsyncThunk(
  'companyAnalysis/industryAnalysis/insurance/profitability',
  async (params, { rejectWithValue }) => {
    try {
      if (params?.isDynamicReport) {
        const {
          vsics,
          companyInfo = {},
          defaultIndustryId,
          compareIndustryId,
        } = params

        const defaultVsicId =
          defaultIndustryId || getDefaultVsic(vsics, companyInfo.mainVsicId).id

        const res = await InsuranceService.postProfitability({
          vsicDefault: defaultVsicId,
          vsicCompare: compareIndustryId,
          organizationId: companyInfo.organizationId,
        })

        return res.success
          ? { data: res.data, defaultVsicId }
          : rejectWithValue({ isLoading: false })
      } else {
        const { vsicDefault, ...others } = params
        const res = await InsuranceService.postProfitability({
          vsicDefault,
          ...others,
        })

        return res.success
          ? { data: res.data, defaultVsicId: vsicDefault }
          : rejectWithValue({ isLoading: false })
      }
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const downloadProfitability = createAsyncThunk(
  'companyAnalysis/industryAnalysis/insurance/profitability/export',
  async (params) => {
    try {
      const res = await InsuranceService.downloadProfitability(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)
